import type { PetitionDetailsPageState } from './types';

export const INITIAL_STATE: PetitionDetailsPageState = {
	signFormStep: 1,
};
